import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hasPartialTypeString'
})
export class HasPartialTypeStringPipe implements PipeTransform {
    transform(objects: any[], partialObjectString: string[]): any {
        if (objects == null) return;

        if (partialObjectString == null) return objects;

        var out = [];

        if (typeof partialObjectString !== 'undefined' && partialObjectString.length > 1) {
            for (var i = 0; i < objects.length; i++) {
                for (var j = 0; j < partialObjectString.length; j++) {
                    if (objects[i].TYPE.indexOf(partialObjectString[j]) >= 0) {
                        if (out.indexOf(objects[i]) == -1) {
                            out.push(objects[i]);
                        }
                        break;
                    }
                }
            }
        } else {
            for (var i = 0; i < objects.length; i++) {
                if (out.indexOf(objects[i]) == -1) {
                    out.push(objects[i]);
                }
                if (objects[i].TYPE.indexOf(partialObjectString) < 0) {
                    out.splice(out.length - 1, 1);
                }
            }
        }

        return out;
    }
}
